<template lang="pug">
div
  .progress(v-if='showProcess', :style='{ width: width + "px" }')
    span(v-if="useMinuteType") <span>{{convertSecondsToMinutes(show_currentTime)}}</span> / {{ convertSecondsToMinutes(time) }}
    span(v-else) <span>{{ show_currentTime }}</span> / {{ time }}
    process(:time='time * 1000', :currentTime='currentTime')
  span.noProcess(v-else) {{ show_currentTime }}
</template>
<script>
import process from './process'
export default {
  name: 'countdown',
  components: { process },
  props: {
    time: 0,
    showProcess: {
      default: false,
    },
    width: {
      default: 456,
    },
    useTime: {
      default: 0,
    },
  },
  data() {
    return {
      startTime: 0,
      currentTime: 0,
      flag: '',
      t2: 0,
      t3: 0
    }
  },
  methods: {
    convertSecondsToMinutes(seconds) {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60
      const formattedMinutes = String(minutes).padStart(2, '0')
      const formattedSeconds = String(remainingSeconds).padStart(2, '0')
      return `${formattedMinutes}:${formattedSeconds}`
    },
    countdown(v) {
      clearTimeout(this.flag)
      this.t2 = +new Date() - this.startTime
      this.startTime = new Date()
      this.t3 = Math.abs(this.t2) > 40000 ? this.t3 : this.t2

      this.currentTime += this.t3
      if (this.show_currentTime <= 0) {
        this.$emit('end')
      } else {
        this.flag = setTimeout(() => {
          this.countdown()
        }, 30)
      }
    },
    getCurrentTime() {
      return this.currentTime
    },
    close() {
      clearTimeout(this.flag)
      this.$emit('end')
    }
  },
  computed: {
    show_currentTime() {
      return this.time - parseInt(this.currentTime / 1000)
    },
    useMinuteType() {
      return this.time > 180
    }
  },
  watch: {
    time: {
      immediate: true,
      handler: function () {
        clearTimeout(this.flag)
        this.startTime = +new Date()
        this.currentTime = this.useTime
        this.countdown()
      },
    },
  },
  destroyed() {
    clearTimeout(this.flag)
  },
}
</script>
<style lang="less" scoped>
.hidden {
  display: none !important;
}
.noProcess {
  color: #fff;
  font-size: 30px;
  font-weight: bold;
}
.progress {
  position: relative;
  width: 100%;
  height: 14px;
  background: #53cc92;
  border-radius: 7px;

  & > span {
    position: absolute;
    top: -24px;
    left: 50%;
    color: #fff;
    font-size: 16px;
    transform: translateX(-50%);

    span {
      color: #fbc564;
      font-size: 16px;
    }
  }

  // @keyframes countdown {
  //   to {
  //     width: 100%;
  //   }
  // }
}
</style>




// WEBPACK FOOTER //
// src/ui/components/countdown/main.vue